import { withStyles, Grid } from '@material-ui/core';
import StopLabelValue from './StopLabelValue';
import Header from './Header';
import {
  getTimeString,
  getTotalValue,
  getDiffInMin,
  getStopShipmentData,
  stopStatus,
  checkIsBefore
} from '../../Utils';
import ProNumberContainer from './ProNumberContainer';
import { getServiceLevel, formatDeliveryOrServiceWindow } from '../../../../Dispatch/utils/utils';
import { STOP_TYPE } from '../../constants';

const styles = (theme) => ({
  container: {
    border: `1px solid ${theme.AppBGColor}`,
    borderRadius: 8,
    marginBottom: 24,
    padding: 18,
    minHeight: '30%'
  },
  scrollable: {
    overflow: 'auto'
  },
  minWidthItem: {
    minWidth: 100
  },
  bottomMargin: {
    marginBottom: 10
  },
  errorContainer: {
    fontSize: theme.textFontSize,
    color: theme.gridOverlayFontColor,
    marginTop: '16%',
    border: `2px solid ${theme.gridOverlayFontColor}`,
    background: theme.gridOverlayBGColor,
    padding: '12px',
    width: 'max-content',
    fontWeight: 500,
    marginLeft: "31%"
  }
});

const StopData = ({ stopData, classes, searchInputValue, route }) => {
  const stopTime = getDiffInMin(stopData.actualDepartureTime, stopData.actualArrivalTime);
  const plannedStopTime = getDiffInMin(stopData.plannedDepartureTime, stopData.plannedArrivalTime);
  const stopStatusDetails = stopStatus(stopData);
  const serviceLevel = getServiceLevel(stopData);
  return (
    <div className={classes.container}>
      <Grid container spacing={24}>
        <Header stopData={stopData} />
        {stopData.stopType !== STOP_TYPE.TrailerDrop ? (
          <>
            <Grid item xs={12}>
              <ProNumberContainer
                stopData={stopData}
                highlighted={searchInputValue}
                route={route}
              />
            </Grid>
            <Grid item container xs={12} className={classes.scrollable}>
              <Grid item container xs={12} wrap="nowrap" className={classes.bottomMargin}>
                <Grid item xs={3} className={classes.minWidthItem}>
                  <StopLabelValue
                    planned={{ value: serviceLevel, toolTip: '' }}
                    label="SERVICE LEVEL"
                  />
                </Grid>
                <Grid item xs={3} className={classes.minWidthItem}>
                  <StopLabelValue
                    planned={{ 
                      value: formatDeliveryOrServiceWindow(stopData.serviceWindow),
                      toolTip: '' 
                    }}
                    label="SERVICE WINDOW"
                  />
                </Grid>
                <Grid item xs={3} className={classes.minWidthItem}>
                  <StopLabelValue
                    planned={{
                      value: stopStatusDetails.status,
                      toolTip: '',
                      isPositiveValue: stopStatusDetails.hasReturnOrException
                    }}
                    label="STATUS"
                  />
                </Grid>
                <Grid item xs={3} className={classes.minWidthItem}>
                  <StopLabelValue
                    planned={{ value: getStopShipmentData(stopData, 'loadingZone'), toolTip: '' }}
                    label="LDG ZONE"
                  />
                </Grid>
              </Grid>
              <Grid item container xs={12} wrap="nowrap" className={classes.bottomMargin}>
                <Grid item xs={3} className={classes.minWidthItem}>
                  <StopLabelValue
                    planned={{ value: stopData.bills || 0, toolTip: '' }}
                    label="BILLS"
                  />
                </Grid>
                <Grid item xs={3} className={classes.minWidthItem}>
                  <StopLabelValue
                    planned={{ value: getTotalValue(stopData.shipments, 'pieces'), toolTip: '' }}
                    label="PIECES"
                  />
                </Grid>
                <Grid item xs={3} className={classes.minWidthItem}>
                  <StopLabelValue
                    planned={{ value: getTotalValue(stopData.shipments, 'hu'), toolTip: '' }}
                    label="HU"
                  />
                </Grid>
                <Grid item xs={3} className={classes.minWidthItem}>
                  <StopLabelValue
                    planned={{ value: getTotalValue(stopData.shipments, 'weight'), toolTip: '' }}
                    label="WEIGHT"
                  />
                </Grid>
              </Grid>
              <Grid item container xs={12} wrap="nowrap" className={classes.bottomMargin}>
                <Grid item xs={3} className={classes.minWidthItem}>
                  <StopLabelValue
                    planned={{
                      value: getTimeString(stopData.plannedArrivalTime),
                      toolTip: 'Planned Arrival Time'
                    }}
                    actual={{
                      value: getTimeString(stopData.actualArrivalTime),
                      toolTip: 'Actual Arrival Time',
                      isPositiveValue: checkIsBefore(
                        stopData.actualArrivalTime,
                        stopData.plannedArrivalTime
                      )
                    }}
                    label="ARRIVAL TIME"
                    showPlannedIcon={Boolean(stopData.plannedArrivalTime)}
                  />
                </Grid>
                <Grid item xs={3} className={classes.minWidthItem}>
                  <StopLabelValue
                    planned={{
                      value: getTimeString(stopData.plannedDepartureTime),
                      toolTip: 'Planned Departure Time'
                    }}
                    label="DEPARTURE TIME"
                    actual={{
                      value: getTimeString(stopData.actualDepartureTime),
                      toolTip: 'Actual Departure Time',
                      isPositiveValue: checkIsBefore(
                        stopData.actualDepartureTime,
                        stopData.plannedDepartureTime
                      )
                    }}
                    showPlannedIcon={Boolean(stopData.plannedDepartureTime)}
                  />
                </Grid>
                <Grid item xs={3} className={classes.minWidthItem}>
                  <StopLabelValue
                    label="TOTAL STOP TIME"
                    planned={{
                      value: `${plannedStopTime || '-'} min(s)`,
                      toolTip: 'Planned Stop Time'
                    }}
                    actual={{
                      value: stopTime || '-',
                      toolTip: 'Actual Stop Time',
                      isPositiveValue:
                        stopTime && plannedStopTime ? stopTime <= plannedStopTime : true
                    }}
                    showPlannedIcon={Boolean(plannedStopTime)}
                  />
                </Grid>
                <Grid item xs={3} className={classes.minWidthItem}>
                  <StopLabelValue
                    planned={{
                      value: `${
                        stopData.geoFenceArrivalTime
                          ? getTimeString(stopData.geoFenceArrivalTime)
                          : ''
                      } - ${
                        stopData.geoFenceDepartureTime
                          ? getTimeString(stopData.geoFenceDepartureTime)
                          : ''
                      }`,
                      toolTip: ''
                    }}
                    label="GEOFENCE"
                  />
                </Grid>
              </Grid>
            </Grid>
          </>
        ) : (
          <Grid item xs={12}>
            <div className={classes.errorContainer}>No data available</div>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default withStyles(styles)(StopData);
